import './Zoom.scss';
import {useParams, useNavigate} from 'react-router-dom';

import 'react-slideshow-image/dist/styles.css'



//useNavigate ( ancien history)  prend -1 pour revenir a l' onglet d avant a la place de goBack()


const Zoom = ({datas}) => {
  
  let navigate = useNavigate();
    
  const {id} = useParams();

 


 
  return(
    
    
    <div className='zoom'>
   
    {datas.filter((data) =>  data.id === id).map((dataF, index) => (
        <img src={dataF.url} alt='pics' key={index} className='zoom_item' onClick={() => navigate(-1)}/>
    ))}

    
    </div>

  )
}

export default Zoom;